import { Logger } from "neo-common";

/**
 * @class AmbientBackground
 */
export class AmbientBackground {
    static changeAmbientBackground(newBackgroundName: string, duration: number = 200, delay: number = 0): void {
        let base = document.getElementById("ambientBackgroundBase");
        let transition = document.getElementById("ambientBackgroundTransition");

        if (base && transition) {
            if (!transition.classList.contains(newBackgroundName)) {
                transition.classList.remove("show");
                base.className = transition.className;

                transition.style.transitionDuration = duration + "ms";
                transition.style.transitionDelay = delay + "ms";
                transition.className = "";
                transition.offsetWidth;
                transition.classList.add(newBackgroundName, "show");
            }
        }
    }

    /**
     * Trace to browser console.
     * @method log
     * @param s string which will be traced to browser console.
     * @return void
     */
    static log(s: string): void {
        if (DEBUG) {
            Logger.debugGroup("Scaling", s);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Utils/AmbientBackground.ts
 **/